(() => {
  const field = document.querySelector(
    '[name="contact[estimated_monthly_sales]"]'
  );

  if (!field) return;

  const label = field.id
    ? document.querySelector(`label[for="${field.id}"]`)
    : null;

  if (label) {
    label.textContent = 'Estimated Monthly Sales (local currency) *';
  }

  if (field.tagName === 'INPUT') {
    field.placeholder =
      'Amount and currency, e.g. THB 250,000, USD 7,500 or EUR 6,500';
    return;
  }

  const input = document.createElement('input');
  input.type = 'text';
  input.id = field.id;
  input.name = field.name;
  input.placeholder =
    'Amount and currency, e.g. THB 250,000, USD 7,500 or EUR 6,500';
  input.required = true;
  field.replaceWith(input);
})();
